export default "__VITE_ASSET__0e3a1be5__"